import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
    Wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        marginBottom: '1rem',
    },
}))

export default useStyles
